import { NavLink } from "react-router-dom";
import { useState } from "react";

import { Controls, ControlsButton } from "@/components/Controls";
import { PageHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";
import { TableHeader } from "@/components/Table";
import ParticipantsPerformanceTable from "./components/ParticipantsPerformanceTable";
import PerformanceCards from "./components/PerformanceCards";
import GamificationDateFilter from "../GamificationBonuses/components/GamificationDateFilter";
import {
  getDateFiltersQueryParams,
  months,
} from "../GamificationBonuses/components/ApprovedBonusesTable";
import ScoreTables from "./components/ScoreTables";

export interface ActivePeriod {
  type: "month" | "period";
  period: string;
}

const LeaderboardOverview = () => {
  const [activePeriod, setActivePeriod] = useState<ActivePeriod>({
    type: "month",
    period: months[0].startOf("month").toFormat("yyyy-LL-dd"),
  });

  const dateParams = getDateFiltersQueryParams(activePeriod);

  return (
    <>
      <Text $type="caption" $color="gray">
        ALL TEAMS
      </Text>
      <PageHeading>Leaderboard Overview</PageHeading>
      <TableHeader>
        <Controls>
          <NavLink
            to="/general/gamification/leaderboard/thumb"
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Thumb
              </ControlsButton>
            )}
          />
        </Controls>
        <GamificationDateFilter
          activePeriod={activePeriod}
          setActivePeriod={setActivePeriod}
        />
      </TableHeader>
      <PerformanceCards activePeriod={activePeriod} dateParams={dateParams} />
      <ScoreTables />
      <ParticipantsPerformanceTable />
    </>
  );
};

export default LeaderboardOverview;
